module.exports = __webpack_public_path__ + "img/api-loading.f84affd.png";